import {
  MDBContainer,
} from 'mdbreact';
import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import {
  translate,
} from 'helperFunctions/translation';
import {
  IFacilityStore
} from 'mobx-store/storeInterfaces/facilitiesInterface';

import { GeneralChartComponent } from 'components/GeneralCharts';
import { ChartTypes } from 'components/GeneralCharts/types';
import { DatePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Button } from '@material-ui/core';
import SnackBarComponent from 'components/SnackBarComponent/SnackBarComponent';

import classes from './style.module.scss';

interface FacilitiesBranchStatisticsProps {
  history?: any;
  match: any;
  facilityStore: IFacilityStore;
}

interface FacilitiesBranchStatisticsState {
  branchFacilitiesData: any;
  from: any;
  to: any;
  branchId: string;
}

type PickU<T, K extends keyof T> = T extends any ? { [P in K]: T[P] } : never;

@inject('facilityStore')
@observer
class FacilitiesBranchStatistics extends Component<FacilitiesBranchStatisticsProps, FacilitiesBranchStatisticsState> {

  constructor(props: FacilitiesBranchStatisticsProps) {
    super(props);
    // console.log(classes.chartFirstColor);
    this.state = {
      branchFacilitiesData: { },
      from: null,
      to: null,
      branchId: props.match.params.id
    };
    console.log('branchId' , props.match.params.id);
  }

   handleFromChanged = async (date: MaterialUiPickersDate) => {
      this.setState({
      from: date,
    });
    await this.changeChartState();

  }

  handleToChanged =  async (date: MaterialUiPickersDate) => {
    console.log('data , data' , date);
     this.setState({
      to: date
    });
    await this.changeChartState();

  }

  filter = async () => {
    try {
      if (!this.state.from || !this.state.to) {
          SnackBarComponent.getInstance().openSnackbar(
            'Start date and end date are required',
            3000,
            'error'
          );
          return ;
      }
      await this.props.facilityStore.getFacilitiesBrnachRatingStatistics(
        +this.state.branchId ,
        `${this.state.from!.c.month}-${this.state.from!.c.day}-${this.state.from!.c.year}`,
        `${this.state.to!.c.month}-${this.state.to!.c.day}-${this.state.to!.c.year}`
        );
         // clear chart data state before setting the state again with new data
         this.setState({
          branchFacilitiesData: {},
        });
      await this.changeChartState();
    } catch (error) {
      SnackBarComponent.getInstance().openSnackbar(
        'Error while Filtering',
        3000,
        'error'
      );
    }
  }
  clearFilter = async () => {
    await this.props.facilityStore!.getFacilitiesBrnachRatingStatistics(+this.state.branchId );
    this.setState({
      branchFacilitiesData: {},
      from: null,
      to: null,
    });
    this.changeChartState();

  }

  changeChartState = async () => {
     this.setState({
      branchFacilitiesData:  {
        labels: this.props.facilityStore?.branchFacilitiesStatistics.labels ,
        datasets: [
        {
          label: 'Facilities Rating',
          fill: false,
          type: 'line',
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.props.facilityStore?.branchFacilitiesStatistics.points
        }
      ]},
    });
  }

  async componentDidMount() {
    await this.props.facilityStore!.getFacilitiesBrnachRatingStatistics(+this.state.branchId);
    this.changeChartState();
  }

  render() {
    return (
          <div>
            <MDBContainer>
              <h3 className='mt-5'>
                {translate('STATISTICS_FACILITIES_BRANCH', {
                })}
              </h3>
              <div className={classes.datePickerContainer}>
                <div>
                <DatePicker
                variant='inline'
                format='MM/dd/yyyy'
                label='From'
                value={this.state.from}
                onChange={(value) => {
                  this.handleFromChanged(value);
                }}
              />
              <DatePicker
                variant='inline'
                format='MM/dd/yyyy'
                label='To'
                value={this.state.to}
                onChange={(value) => {
                  this.handleToChanged(value);
                }}
              />
                </div>
                <div>
                <Button onClick={this.clearFilter}   color='primary'  variant='contained'>Clear</Button>
                <Button onClick={this.filter}   color='primary'  variant='contained'>Filter</Button>
                </div>
              </div>
              <GeneralChartComponent type={ChartTypes.LINE} data={this.state.branchFacilitiesData} />
            </MDBContainer>
          </div>
    );
  }
}

export default FacilitiesBranchStatistics;
